/**
 * Created by tomers on 6/18/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/skills/skillsGridRowView.tmpl");

    var Checkbox = require("ui/checkbox/Checkbox");
    var PlusCompositeView = require('ui/plus-composite-view/PlusCompositeView');
    var TimeUtils = require("reporting-assets/js/TimeUtils");

    var SkillsGridRowView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        SkillsGridRowView = Marionette.ItemView.extend({
            tagName: "tr",
            className: "skill-row",
            template: template,
            ui: {
                selector: ".selector",
                name: ".name",
                description: ".description",
                responseTime: ".response-time",
                lobs: ".lobs",
                lobsComponentContainer: ".lobs-container"
            },
            uiComponents: {
                selectorCheckbox: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.selector",
                        checked: false,
                        label: "",
                        permutation: Checkbox.PERMUTATION.B // no label
                    },
                    events: {
                        "change": "_onSelectorChange"
                    }
                }
            },
            events: {
                "click @ui.selector": "_onSelectorWrapperClick",
                "click @ui.name": "_onRowClick",
                "click @ui.responseTime": "_onRowClick",
                "click @ui.description": "_onRowClick",
                "click @ui.lobs": "_onRowClick"
            },

            initialize: function() {
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.SKILL_LIST);
                this._bindEvents();
            },

            _bindEvents: function (checked) {
                this.listenTo(this.model, "model:selection:change", this._onModelSelectionChange);
            },


            onRender: function() {
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    this.ui.lobs.removeClass("hide");

                    this.uiComponents.host$.createAndRender("lobsComponent", {
                        type: PlusCompositeView,
                        options: {
                            el: this.ui.lobsComponentContainer,
                            collection: this._buildLobsList(),
                            textModelAttr: "tooltip",
                            visibleItemsCount: 2,
                            itemView: PlusCompositeView.DefaultPlusComponentItemView
                        }
                    });
                }
                if (LE.sessionManager.hasSLAPerSkillFeature()) {
                    this.ui.responseTime.removeClass("hide");
                }
            },

            customTemplateHelpers: function() {
                var defaultResponseTimeInSeconds = this.model.getSlaDefaultResponseTime();
                var translatedDefaultResponseTime;
                if (defaultResponseTimeInSeconds) {
                    var defaultResponseTimeUnit = TimeUtils.getSlaTimeUnitFromSeconds(defaultResponseTimeInSeconds);
                    var defaultResponseTimeInUnit = TimeUtils.convertSecondsToDaysHoursAndMinutes(defaultResponseTimeInSeconds);
                    defaultResponseTimeInUnit = defaultResponseTimeInUnit.days || defaultResponseTimeInUnit.hours || defaultResponseTimeInUnit.minutes;
                    translatedDefaultResponseTime = LE.translator.translate({
                        key: "LEUserManagement.skillList.column.responseTime.unit." + defaultResponseTimeUnit,
                        args: [defaultResponseTimeInUnit]
                    });
                }
                return {
                    responseTime: translatedDefaultResponseTime
                };
            },

            _buildLobsList: function(){
                var lobsCollection = LEUserManagement.getDataManager().getLobsCollection();
                var skillLobsArr = [];
                _.each(this.model.getLobs(),function(lobId){

                    var lobModel =  lobsCollection.get(lobId);
                    if (lobModel){
                        skillLobsArr.push({
                            name: lobModel.getName(),
                            tooltip: lobModel.getName(),
                            activeTooltip: true
                        });
                    }
                });
                this._sortArrByName(skillLobsArr);
                return new PlusCompositeView.DefaultPlusComponentCollection(skillLobsArr);
            },

            _sortArrByName: function(skillLobsArr){
                skillLobsArr.sort(function(a, b){
                    return a.name.toLowerCase() > b.name.toLowerCase() ? 1:-1;
                });
            },

            _onSelectorWrapperClick: function(e) {
                if ($(e.target).hasClass("selector")) {
                    this.uiComponents.selectorCheckbox.checkboxClick();
                }
            },

            _onRowClick: function() {
                this.channel.trigger("row:click", this.model);
            },

            _onSelectorChange: function(componentId, eventName, isChecked) {
                this.channel.trigger("row:selector:click", {itemModel:this.model, isChecked:isChecked});
            },

            _onModelSelectionChange: function(isChecked) {
                this.$el.toggleClass("selected", isChecked);
                this.uiComponents.selectorCheckbox.setCheckedState(isChecked);
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return SkillsGridRowView;
});
